import { createSlice } from "@reduxjs/toolkit";
import { fetchOrganization } from "../organization/slice";
import adapter from "./adapter";

const initialFormEmpty = {
  id: '',

  // About
  name: '',
  established_since: 0,
  image: '',
  approaches: [],
  audiences: [],
  issues: [],
  types: [],

  // Contact & Location
  email: '',
  phone: '',
  address: '',
  pin_point: '',

  // Milestones
  milestones: [],

  // Partners
  partners: [],
  partners_external: [],

  // Featured Items
  events: [],
  resources: [],
  blogs: []
}

const initialMilestoneEmpty = {
  year: new Date().getFullYear(),
  description_id: 'N/A',
  description_en: 'N/A'
}

const initialState = {
  _payload: null,
  status: "idle",
  error: "",
  data: initialFormEmpty,

  // nested
  milestone: initialMilestoneEmpty,
  partner: {
    partners: [],
    partners_external: [],
    active_form: 'internal', // internal || external
    form: {}
  }
};

export const organizationFormSlice = createSlice({
  name: "organizationForm",
  initialState,
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    },
    updateForm(state, action){
      state.data[action.payload.key] = action.payload.value
    },
    reset(state){
      state.data = initialFormEmpty
    },
    setMilestone(state, action){
      state.milestone = action.payload
    },
    resetMilestone(state) {
      state.milestone = initialMilestoneEmpty
    },
    updateMilestone(state, action){
      state.milestone[action.payload.key] = action.payload.value
    },
    updatePartner(state, action){
      state.partner[action.payload.key] = action.payload.value
    },
    updatePartnerForm(state, action){
      state.partner.form[action.payload.key] = action.payload.value
    },
    setActivePartnerForm(state, action){
      state.partner.active_form = action.payload
    }
  },
  extraReducers: {
    [fetchOrganization.fulfilled]: (state, action) => {
      const organization = adapter.responseBodyToForm(action.payload)
      state._payload = action.payload
      state.data = {...state.data, ...organization}
    },
  }
});

export const {
  setStatus,
  updateForm,
  reset,

  // nested
  setMilestone,
  resetMilestone,
  updateMilestone,
  updatePartner,

  setActivePartnerForm,
  updatePartnerForm,
} = organizationFormSlice.actions

export default organizationFormSlice.reducer;
